export interface LoyaltyProgramRowsState {
  initialRows: Array<LoyaltyProgramRow>;
  currentRows: Array<LoyaltyProgramRow>;
}
export interface LoyaltyProgramConfig {
  program: string;
  name: string;
}

export interface LoyaltyProgramRow {
  id: string;
  program: string;
  memberNumber: string;
  type: 'flight' | 'hotel';
}

export const frequentFlyerProgramsConfig: Record<string, LoyaltyProgramConfig> = {
  qantas: {
    program: 'qantas',
    name: 'Qantas Frequent Flyer',
  },
  velocity: {
    program: 'velocity',
    name: 'Virgin Velocity',
  },
};

export const hotelLoyaltyProgramsConfig: Record<string, LoyaltyProgramConfig> = {
  'Accor Live Limitless': {
    program: 'Accor Live Limitless',
    name: 'Accor Live Limitless',
  },
  'Best Western Rewards': {
    program: 'Best Western Rewards',
    name: 'Best Western Rewards',
  },
  'Choice Privileges': {
    program: 'Choice Privileges',
    name: 'Choice Privileges',
  },
  'EVT Stays': {
    program: 'EVT Stays',
    name: 'EVT Stays',
  },
  'World of Hyatt': {
    program: 'World of Hyatt',
    name: 'World of Hyatt',
  },
  'IHG One Rewards': {
    program: 'IHG One Rewards',
    name: 'IHG One Rewards',
  },
  'GHA Discovery': {
    program: 'GHA Discovery',
    name: 'GHA Discovery',
  },
  'Radisson Rewards': {
    program: 'Radisson Rewards',
    name: 'Radisson Rewards',
  },
  'Wyndham Rewards': {
    program: 'Wyndham Rewards',
    name: 'Wyndham Rewards',
  },
};
